

// export const server = `http://localhost:8080`;
// export const server = `http://0.0.0.0:8080`;
// export const server = `https://api.mockm8.com`;

// export const server = `http://mockamte-backend.ap-south-1.elasticbeanstalk.com`;
// export const server = `https://mockmate-prod.ap-south-1.elasticbeanstalk.com`;


export const server = `https://mockmate-backend-m6i9.onrender.com`;